// Experiment 4 : Login form (copied from Register and removed the name field)
// Experiment 5 : now checks the user in MongoDB through server.js
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";

function Login() {
  const { register, handleSubmit, formState: { errors } } = useForm();
  const [message, setMessage] = useState("");
  const [userName, setUserName] = useState("");

  // ----- Exp 4 version: checked localStorage -----
  // const onSubmit = (data) => {
  //   const user = JSON.parse(localStorage.getItem(data.email));
  //   if (user && user.password === data.password) {
  //     setMessage("Login successful, welcome " + user.name);
  //     setUserName(user.name);
  //   } else {
  //     setMessage("Wrong email or password");
  //     setUserName("");
  //   }
  // };

  // ----- Exp 5 version: ask server.js, which checks MongoDB -----
  const onSubmit = async (data) => {
    try {
      const response = await fetch("/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: data.email, password: data.password })
      });
      const result = await response.json();

      if (result.success) {
        setMessage("Login successful, welcome " + result.name);
        setUserName(result.name);
      } else {
        setMessage(result.error || "Wrong email or password");
        setUserName("");
      }
    } catch (err) {
      setMessage("Server not running");
    }
  };

  return (
    <div className="container">
      <h2>Login Form</h2>
      <form className="form" onSubmit={handleSubmit(onSubmit)}>
        <input type="email" placeholder="Email" {...register("email", { required: true })} />
        {errors.email && <span>Email is required</span>}

        <input type="password" placeholder="Password" {...register("password", { required: true })} />
        {errors.password && <span>Password is required</span>}

        <input type="submit" value="Login" />
      </form>

      <p>New user? <a href="/form/">Register here</a></p>
      <p>{message}</p>
      {userName && <Link to={"/user/" + userName}>Go to my profile</Link>}
    </div>
  );
}

export default Login;
